import { render, staticRenderFns } from "./qutable.vue?vue&type=template&id=0c71d303&scoped=true&"
import script from "./qutable.vue?vue&type=script&lang=js&"
export * from "./qutable.vue?vue&type=script&lang=js&"
import style0 from "./qutable.vue?vue&type=style&index=0&id=0c71d303&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71d303",
  null
  
)

export default component.exports